export default __webpack_public_path__ + "media/images/images/portfolio/width-600/portfolio-18-569fa75be034afa16bb260e592db8152.jpg";